app.controller("clinicLetterController", [
	"$scope",
	"$mdDialog",
	"PracticeService",
	"Session",
	"ClinicLettersAPI",
	"NHISearchPatientsAPI",
	"$filter",
	"SurgeryAgreementAPI",
	"Base64",
	"CurrentPatient",
	"$modal",
	"$state",
	"$stateParams",
	"$rootScope",
	"BackgroundAPIService",
	"PatientVisionAPI",
	"LINE",
	"DEVICE",
	"DiagnosisAPI",
	"countryConfig",
	"ENV",
	"FileUploader",
	"PatientRecordLiveUpdateService",
	"SignOffService",
	function (
		$scope,
		$mdDialog,
		PracticeService,
		Session,
		ClinicLettersAPI,
		NHISearchPatientsAPI,
		$filter,
		SurgeryAgreementAPI,
		Base64,
		CurrentPatient,
		$modal,
		$state,
		$stateParams,
		$rootScope,
		BackgroundAPIService,
		PatientVisionAPI,
		LINE,
		DEVICE,
		DiagnosisAPI,
		countryConfig,
		ENV,
		FileUploader,
		PatientRecordLiveUpdateService,
		SignOffService
	) {
		// The recipient pickers are drawn from the care team. Another user adding to it while this
		// letter is being written - or a referral upload adding the GP - refreshes them in the
		// background, so the letter can be addressed to someone who was not there when it was opened.
		PatientRecordLiveUpdateService.subscribeCareTeam($scope, {
			patientId: function () {
				return $scope.CP && $scope.CP.patient && $scope.CP.patient.id;
			},
			reload: function () {
				fetchCareTeam({ background: true });
			},
		});

		this.$onInit = function () {
			$scope.transcriptionEnabled = countryConfig.transcriptionFeatureEnabled;
			$scope.templateSetting = { checked: false, applyToAllUserPractices: true, name: "", selectedTemplate: null };
			fetchTemplates();

			setTimeout(() => {
				$scope.isReady = true;
				$scope.$apply();
				fetchSetting();
			}, 100);

			if ($stateParams.createTemplate || $stateParams.templateId) {
				$scope.templateSetting.checked = true;
				$scope.templateSetting.applyToAllUserPractices = true;
				$scope.templateMappings = {};
			} else {
				createTemplateMappings();
				loadSignOffSettings();
			}
		};

		$scope.user_recipients = [];
		$scope.hpi_recipients = [];
		$scope.custom_emails = [];
		$scope.edis = [];

		$scope.care_team_options = [];

		$scope.sendHL7 = { value: false };

		$scope.allowNavigation = true;

		// The patient this screen was opened for. The nav bar and the patient header both sit on this
		// page, so a user can pick a different patient without leaving the letter - and when the
		// unsaved-changes prompt below cancels the transition, they stay here with someone else loaded.
		// Everything this screen sends is addressed to the letter's patient (see letterPatientId), and
		// the header is put back to match so the two can't disagree.
		var letterPatient = angular.copy(CurrentPatient.patient);

		function restoreLetterPatient() {
			if (!letterPatient || !letterPatient.id) {
				return;
			}
			if (CurrentPatient.patient && CurrentPatient.patient.id === letterPatient.id) {
				return;
			}
			CurrentPatient.setPatient(angular.copy(letterPatient), letterPatient.appointment);
		}

		var deregisterStateChangeStart = $rootScope.$on("$stateChangeStart", function (event, toState, toParams) {
			if (!$scope.allowNavigation) {
				event.preventDefault(); // Stop navigation
				if (confirm("You have unsaved changes, are you sure to leave ?")) {
					$scope.allowNavigation = true; // Unblock automatically after user clicks OK
					$state.go(toState.name, toParams); // Retry transition, with the params it was asked for
				} else {
					// Staying put. Whatever selected the new patient has already swapped it in.
					restoreLetterPatient();
				}
			}
		});

		$scope.HPI = NHISearchPatientsAPI;
		$scope.today = $filter("date")(new Date(), "dd/MM/yyyy");
		$scope.SAAPI = SurgeryAgreementAPI;
		$scope.CP = CurrentPatient;

		// This logic adds GP info from HPI to letter CC.
		// It will always add practitioner, but if org and loc are identical it will only add one of them.
		// If org and loc have the same name but different edi/email, then it will suffix the names with (org) and (loc).
		let gpInfoProcessed = false;

		// Returns true if the given email is already a recipient in either the To or CC list.
		const emailAlreadyPresent = (email) => {
			if (!email) return false;
			const inList = (list) => list.some((r) => r.type === "EMAIL" && (r.obj ?? r.name) === email);
			return inList($scope.full_recipients.to) || inList($scope.full_recipients.cc);
		};

		const processGPInfo = (gpInfo) => {
			// Only process the GP once per letter; both the CP.gp watcher and fetchCareTeam can invoke this.
			if (gpInfoProcessed) {
				return;
			}
			gpInfoProcessed = true;

			// Always add the practitioner
			if (gpInfo.practitioner && gpInfo.practitioner.email) {
				// Prevent duplicates across both To and CC.
				if (!emailAlreadyPresent(gpInfo.practitioner.email)) {
					$scope.full_recipients.cc.push({
						type: "EMAIL",
						name: gpInfo.practitioner.name,
						obj: gpInfo.practitioner.email,
					});
				}
			}

			// Determine whether to add Org, Loc, or both
			const org = gpInfo.organisation;
			const loc = gpInfo.location;

			let addOrg = !!org;
			let addLoc = false;

			const safeLower = (val) => (val ? val.toString().toLowerCase().trim() : "");

			const orgName = org ? safeLower(org.name) : "";
			const locName = loc ? safeLower(loc.name) : "";

			if (loc) {
				if (!org) {
					addLoc = true; // No org, so definitely add the location
				} else {
					const orgEmail = safeLower(org.email);
					const locEmail = safeLower(loc.email);
					const orgEdi = safeLower(org.edi);
					const locEdi = safeLower(loc.edi);

					// Check routing equivalence: 
					// If the contact routing info (email or EDI) differs in ANY way, add both.
					// We ignore name differences here because if they route to the exact 
					// same endpoints, adding the second one is functionally redundant.
					if (orgEmail !== locEmail || orgEdi !== locEdi) {
						addLoc = true;
					}
				}
			}

			// Determine if suffixes are needed for display disambiguation
			let orgSuffix = "";
			let locSuffix = "";

			if (addOrg && addLoc && orgName === locName && orgName !== "") {
				orgSuffix = " (org)";
				locSuffix = " (loc)";
			}

			// Helper to search and add to CC list
			const searchAndAdd = (entity, suffix) => {
				if (entity && entity.name) {
					// Search the API using the real name
					$scope.API.searchPracticeDirectory(entity.name).then(
						(resp) => {
							if (resp.data.length > 0) {
								const result = resp.data[0];

								// Check if it already exists before pushing
								const exists = $scope.full_recipients.to.concat($scope.full_recipients.cc).some(
									(r) => r.type === "PRACTICE_DIRECTORY" &&
										r.obj &&
										r.obj.practice_directory_id === result.practice_directory_id
								);

								if (!exists) {
									$scope.full_recipients.cc.push({
										type: "PRACTICE_DIRECTORY",
										name: `${result.practice_name} ${result.region ? `(${result.region}) ` : ""}${suffix}`,
										obj: result,
									});
								}
							}
						},
						(error) => console.error("Practice directory search failed", error && error.status)
					);
				}
			};

			// Execute searches
			if (addOrg) searchAndAdd(org, orgSuffix);
			if (addLoc) searchAndAdd(loc, locSuffix);
		};

        //listen to current patient gp info change, update recipient options accordingly
		$scope.$watch(
			"CP.gp",
			function (newValue, oldValue) {
				// Prevent execution on the initial Angular digest cycle
				if (newValue === oldValue) {
					return;
				}

				if (newValue) {
					// only if letter is new
					if (!$stateParams.id) {
						processGPInfo(newValue);
					}
				}
			},
			true,
		);

		$scope.full_recipients = {
			to: [],
			cc: [],
		};

		$scope.placeholder_recipients = ["Click to edit recipients"];

		$scope.visionData = null;
		$scope.diagnosisData = null;

		$scope.isReady = false;
		$scope.myColor = "#FF0000";
		$scope.practiceAPI = PracticeService;
		$scope.appointment_categories = [];
		$scope.$mdDialog = $mdDialog;
		$scope.newType = { colour: "FFFFFF", duration: 10 };
		$scope.Session = Session;
		$scope.letter = {
			content: "",
			clinic_date_UTC: $scope.today,
			clinical_letter_id: null,
			patient_id: letterPatient ? letterPatient.id : null,
		};

		$scope.API = ClinicLettersAPI;

		/**
		 * The patient every request from this screen is addressed to. The API finds a letter inside its
		 * patient's records, so sending someone else's id makes an existing letter look like it doesn't
		 * exist. Pinned when the screen opens and replaced by the server's own value once the letter has
		 * been loaded or started - never read from CurrentPatient at save time, which can be switched
		 * from the nav while the letter is still open.
		 */
		function letterPatientId() {
			return $scope.letter.patient_id || ($scope.CP.patient && $scope.CP.patient.id);
		}

		$scope.$on("$viewContentLoaded", function () {
			if (!$stateParams.templateId && !$stateParams.createTemplate) {
				fetchCareTeam();
			}
		});

		$scope.isOverSize = false;
		$scope.change = function (contents) {
			if ($scope.letter.content !== contents) {
				$scope.allowNavigation = false;
			} else if (contents === "<p><br></p>") {
				$scope.allowNavigation = true;
			} else {
				$scope.allowNavigation = true;
			}
			
			// select all and delete all case
			if(contents === '<p><br></p>'){
				$("#summernote").summernote("code", '<p><span style="font-size: 12px;">\ufeff</span></p>');
				return;
			}
            // console.log(contents);
			const size = new Blob([Base64.encode(contents)]).size;
			if (size / 1024 > 5 * 1024) {
				alert("Images must not exceed 5MB in total");
				$scope.isOverSize = true;
			} else {
				$scope.isOverSize = false;
			}
		};

		 $scope.keydown = function (e) {
				const isEmpty =
					$scope.letter.content.trim() === '<p><span style="font-size: 12px;">\ufeff</span><br></p>' ||
					$scope.letter.content.trim() === '<p><span style="font-size: 12px;">\ufeff</span></p>';
				if (e.keyCode === 8 && isEmpty) {
					e.preventDefault();
				}
			};

		$scope.saved_user_signature_image = null;
		$scope.signatureClinician = {};
		$scope.uploadedItem = {};
		$scope.uploader = new FileUploader({
			queueLimit: 1,
		});
		$scope.boundingBox = {
			width: 600,
			height: 600,
		};

		function setCreateOrUpdateSignatureButtonLabel(label) {
			$scope.toolbar_create_update_signature_btn
				.html(`<i class="fa fa-pencil-square-o"/> ${label}`)
				.attr("title", label)
				.attr("data-original-title", label);
		}

		function dataURLToBlob(dataURL) {
			const parts = dataURL.split(";base64,");
			const contentType = parts[0].split(":")[1];
			const raw = window.atob(parts[1]);
			const rawLength = raw.length;
			const uInt8Array = new Uint8Array(rawLength);

			for (let index = 0; index < rawLength; index++) {
				uInt8Array[index] = raw.charCodeAt(index);
			}

			return new Blob([uInt8Array], { type: contentType });
		}

		$scope.useClinicianSignature = function (accept) {
			const signature = accept();
			if (signature.isEmpty || !signature.dataUrl) {
				return;
			}

			$scope.SAAPI.isProcessing = true;
			$scope.SAAPI.uploadSignature(Session.user.id, dataURLToBlob(signature.dataUrl))
				.then(
					function () {
						$scope.saved_user_signature_image = signature.dataUrl;
						$scope.signatureClinician = { dataUrl: signature.dataUrl };
						$scope.toolbar_sign_btn.prop("disabled", false);
						setCreateOrUpdateSignatureButtonLabel("Update Signature");
						$scope.signatureModal.hide();
					},
					function () {
						showGenericErrorModal();
					}
				)
				.then(() => ($scope.SAAPI.isProcessing = false));
		};

		$scope.insertIntoEditor = function (text) {
			if (!text) return;

			// Wrap the entire text in a single div to prevent Summernote's reverse-order bug
			var wrappedText = '<div class="ai-inserted"><span>' + text + '</span></div>';
			var $editor = $('#summernote');

			// 1. Bring focus back to the editor
			$editor.summernote('focus');

			// 2. Put the cursor exactly where we saved it (if a save exists)
			$editor.summernote('restoreRange');

			// 3. Try to paste at the cursor position
			try {
				$editor.summernote('pasteHTML', sanitizer(wrappedText));
			} catch (e) {
				// 4. FALLBACK: If pasteHTML crashes (empty range bug), append to the end
				console.warn("Cursor position lost or never set. Appending text to the end of the editor.");

				var currentContent = $editor.summernote('code');

				// Handle Summernote's default empty state to avoid weird spacing
				if (currentContent === '<p><br></p>') {
					currentContent = '';
				}

				$editor.summernote('code', currentContent + wrappedText);

				// Move cursor to the end after appending
				$editor.summernote('focus');
			}
		};

		function fetchSetting() {
			$scope.SAAPI.getSettings().then(
				function (resp) {
					$scope.surgeryAgreementSettings = angular.copy(resp.data.surgery_agreement_settings.procedure_settings);
					if (resp.data.surgery_agreement_settings.saved_user_signature_image) {
						$scope.saved_user_signature_image =
							"data:image/png;base64," + resp.data.surgery_agreement_settings.saved_user_signature_image;
						$scope.signatureClinician = { dataUrl: $scope.saved_user_signature_image };
						setCreateOrUpdateSignatureButtonLabel("Update Signature");
					} else {
						$scope.toolbar_sign_btn.prop("disabled", true);
						setCreateOrUpdateSignatureButtonLabel("Create Signature");
					}
				},
				function (error) {
					console.error("Fetch signature settings failed", error && error.status);
					$scope.toolbar_sign_btn.prop("disabled", true);
				}
			).then(()=>{
				$("#summernote").summernote("fontSize", 12);
			});
		}


		// Example using string replace and regex (simplified for illustration)
		function sanitizerFontTag(htmlContent) {
			return sanitizer(htmlContent).replace(/<font color="(.*?)"(?: face="(.*?)")?>(.*?)<\/font>/g, function(match, color, face, content) {
				var style = `color: ${color};`;
				if (face) {
					style += ` font-family: ${face};`;
				}
				return `<span style="${style}">${content}</span>`;
			});
		}

		/**
		 * The body for starting a letter. It carries the recipients too, so a new letter is complete in
		 * one request - saving them in a second request meant reading back a letter that had only just
		 * been written, which the API is not guaranteed to see yet.
		 */
		function composeStartPayload() {
			return {
				...composePayload(),
				clinical_letter_template_id: $scope.templateSetting.selectedTemplate
					? $scope.templateSetting.selectedTemplate.clinical_letter_template_id
					: null,
			};
		}

		function composePayload() {
			const recipients = [];
			const fun = (isTo) => (t) => {
				if (t.type === "EMAIL") {
					recipients.push({
						clinical_letter_recipient_type: "EMAIL",
						clinical_letter_recipient_send_type: isTo ? "TO" : "CC",
						email: t.obj ?? t.name,
					});
				} else if (t.type === "EDI" && !t.isInvalid) {
					recipients.push({
						clinical_letter_recipient_type: "EDI",
						clinical_letter_recipient_send_type: isTo ? "TO" : "CC",
						edi: t.name,
					});
				} else if (t.type === "PRACTICE_DIRECTORY") {
					recipients.push({
						clinical_letter_recipient_type: "PRACTICE_DIRECTORY",
						clinical_letter_recipient_send_type: isTo ? "TO" : "CC",
						practice_directory: t.obj,
					});
				} else if (t.type === "PRACTICE_ID") {
					recipients.push({
						clinical_letter_recipient_type: "PRACTICE_ID",
						clinical_letter_recipient_send_type: isTo ? "TO" : "CC",
						practice_id: t.obj.practice_id,
					});
				}
			};

			$scope.full_recipients.to.forEach(fun(true));
			$scope.full_recipients.cc.forEach(fun(false));
			return {
				content: sanitizerFontTag($scope.letter.content),
				clinic_date_UTC: $scope.letter.clinic_date_UTC,
				recipients,
				...composeSignOffPayload(),
			};
		}

		$scope.saveOrUpdate = function () {
			$scope.API.isProcessing = true;

			// One request either way. A new letter used to be started and then immediately updated to
			// attach its recipients, which read the letter back within milliseconds of writing it.
			var save = $scope.letter.clinical_letter_id
				? $scope.API.updateLetter(letterPatientId(), $scope.letter.clinical_letter_id, composePayload())
				: $scope.API.startClinicLetter(letterPatientId(), composeStartPayload());

			save
				.then(
					function (resp) {
						recordLetterIdentity(resp.data);
						showGenericSuccessModal("Draft letter has been saved. Please approve this draft to send the letter.", false);
						$scope.allowNavigation = true;
					},
					function () {
						showGenericErrorModal();
					}
				)
				.then(() => ($scope.API.isProcessing = false));
		};

		$scope.renderTemplate = function () {
			if ($scope.templateSetting.selectedTemplate) {
				$scope.API.fetchTemplateById(
					$scope.templateSetting.selectedTemplate.clinical_letter_template_id,
					$scope.templateSetting.selectedTemplate.practice_id
				).then(
					function (resp) {
						$scope.letter.content = sanitizer(applyTemplateParameters(Base64.decode(resp.data.content)));
					},
					function (e) {
						console.error("Fetch template failed", e && e.status);
					}
				);
			}
		};

		$scope.templateList = [];

		function fetchTemplates() {
			$scope.API.isProcessing = true;
			$scope.API.fetchTemplate()
				.then(
					function (resp) {
						$scope.templateList = angular.copy(resp.data).sort(function compareFn(a, b) {
							return b.used_by_user_ids.length - a.used_by_user_ids.length;
						});

						if ($stateParams.templateId) {
							$scope.templateSetting.checked = true;
							$scope.templateSetting.applyToAllUserPractices = true;

							const selectedTemplate = $scope.templateList.find(
								(t) => t.clinical_letter_template_id === $stateParams.templateId
							);

							if (selectedTemplate) {
								$scope.templateSetting.selectedTemplate = selectedTemplate;
								$scope._updateTemplate();
							}
						}
					},
					function (e) {
						console.error("Fetch template failed", e && e.status);
					}
				)
				.then(() => ($scope.API.isProcessing = false));
		}

		$scope.popoverDeleteTemplate = {
			content: "Delete template",
		};

		$scope.popoverUpdateTemplate = {
			content: "Update template",
		};

		$scope.isTemplatedEdit = false;
		$scope._updateTemplate = function () {
			$scope.templateSetting.checked = true;
			$scope.templateSetting.name = $scope.templateSetting.selectedTemplate.name;
			$scope.isTemplatedEdit = true;

			$scope.API.fetchTemplateById($scope.templateSetting.selectedTemplate.clinical_letter_template_id, $scope.templateSetting.selectedTemplate.practice_id)
				.then(
					function (resp) {
						$scope.letter.content = Base64.decode(resp.data.content);
					},
					function (e) {
						console.error("Fetch template failed", e && e.status);
					}
				)
		};

		$scope.$watch(
			"templateSetting.checked",
			function (newValue, oldValue) {
				if (!newValue) {
					$scope.templateSetting.name = "";
					$scope.isTemplatedEdit = false;
					$scope.renderTemplate();
				}
			},
			true
		);

		$scope.updateTemplate = function () {
			if (!$scope.templateSetting.selectedTemplate) {
				return;
			}
			const template = $scope.templateSetting.selectedTemplate;
			BackgroundAPIService.saveTemplate(template.clinical_letter_template_id, {
				...template,
				name: $scope.templateSetting.name,
				content: Base64.encode($scope.letter.content),
			});
			$scope.allowNavigation = true;
			$state.go("patient-dashboard");
		};

		$scope.deleteTemplate = function () {
			$scope.API.isProcessing = true;
			// ClinicLettersAPI has no addOrUpdateTemplate; templates are deleted one at a time by id.
			$scope.API.deleteTemplate($scope.templateSetting.selectedTemplate.clinical_letter_template_id)
				.then(
					function () {
						showGenericSuccessModal("Delete template successfully", true);
					},
					function () {
						showGenericErrorModal();
					}
				)
				.then(() => ($scope.API.isProcessing = false));
		};

		$scope.saveTemplate = function () {
			$scope.allowNavigation = true;

			BackgroundAPIService.addTemplate({
				practice_id: Session.practice.id,
				name: $scope.templateSetting.name,
				content: Base64.encode($scope.letter.content),
			});

			$scope.allowNavigation = true;
			$state.go("patient-dashboard");
		};

		$scope.getButtonName = function () {
			if ($scope.templateSetting.checked && $scope.isTemplatedEdit) {
				return "UPDATE TEMPLATE";
			} else if ($scope.templateSetting.checked) {
				return "SAVE TEMPLATE";
			} else if ($scope.letter.clinical_letter_id) {
				return "SAVE DRAFT";
			}
			return "SAVE DRAFT";
		};

		$scope.clickButton = function () {
			if ($scope.templateSetting.checked && $scope.isTemplatedEdit) {
				$scope.updateTemplate();
			} else if ($scope.templateSetting.checked) {
				$scope.saveTemplate();
			} else {
				$scope.saveOrUpdate();
			}
		};

		$scope.onTemplateNameChange = function () {
			let isSameTemplate = false;
			if ($scope.templateSetting.selectedTemplate) {
				isSameTemplate = $scope.templateSetting.selectedTemplate.name === $scope.templateSetting.name;
			}
			if (
				$scope.templateList.some(
					(t) =>
						$scope.templateSetting.name && t.name.toLowerCase() === $scope.templateSetting.name.toLowerCase() && !isSameTemplate
				)
			) {
				$scope.clinicLetterForm.template_name.$setValidity("duplicateName", false);
			} else {
				$scope.clinicLetterForm.template_name.$setValidity("duplicateName", true);
			}
		};

		$scope.deleteLetter = function () {
			$scope.negativeButton = null;
			$scope.generalModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.general.tpl.html",
				show: true,
				title: "Delete Clinic Letter",
				content: "Are you sure you want to delete this clinic letter? It can’t be undone.",
				backdrop: true,
				keyboard: false,
				onHide: function () {
					angular.element("body").removeClass("modal-open").css("overflow", "auto");
				},
			});
		};

		$scope.previewLetter = function () {
			$scope.API.isProcessing = true;

			let savePromise;

			if ($scope.letter.clinical_letter_id) {
				savePromise = $scope.API.updateLetter(letterPatientId(), $scope.letter.clinical_letter_id, composePayload());
			} else {
				savePromise = $scope.API.startClinicLetter(letterPatientId(), composeStartPayload()).then(function (resp) {
					recordLetterIdentity(resp.data);
				});
			}

			savePromise
				.then(
					function () {
						$scope.pdfUrl =
							ENV.API +
							`/api/documents/patient/${letterPatientId()}/document/CLINICAL_LETTER/${$scope.letter.clinical_letter_id}`;
						$scope.httpHeaders = {
							Authorization: `Bearer ${Session.token}`,
							"X-PRACTICE-ID": `${Session.practice.id}`,
						};
						$scope.scroll = 0;
						$scope.loading = "loading";

						$scope.onLoad = function () {
							$scope.loading = "";
						};

						$scope.pdfViewerModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.pdf-viewer.tpl.html",
							show: true,
							title: "DOCUMENT PREVIEW",
							backdrop: true,
							keyboard: false,
							onHide: function () {
								angular.element("body").removeClass("modal-open").css("overflow", "auto");
							},
						});
					},
					function () {
						showGenericErrorModal();
					}
				)
				.finally(function () {
					$scope.API.isProcessing = false;
					$scope.allowNavigation = true;
				});
		};

		$scope.closePdfViewer = function () {
			if ($scope.pdfViewerModal) {
				$scope.pdfViewerModal.hide();
			}
		};

		$scope.onGeneralClick = function () {
			if ($scope.generalModal) {
				$scope.generalModal.hide();
				$scope.negativeButton = null;
			}

			$scope.API.isProcessing = true;
			$scope.API.deleteLetter(letterPatientId(), $scope.letter.clinical_letter_id)
				.then(
					function (resp) {
						showGenericSuccessModal("Delete clinic letter successfully", true);
					},
					function (error) {
						showGenericErrorModal();
					}
				)
				.then(() => ($scope.API.isProcessing = false));
		};

		function showGenericErrorModal() {
			if ($scope.serverErrorModal) {
				$scope.serverErrorModal.hide();
			}
			$scope.serverErrorModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
				show: true,
				title: "CatTrax has encountered an error",
				keyboard: false,
				backdrop: "static",
				onHide: function () {
					angular.element("body").removeClass("modal-open").css("overflow", "auto");
				},
			});
		}

		function showGenericSuccessModal(content, redirect) {
			if ($scope.successModal) {
				$scope.successModal.hide();
			}
			$scope.successModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.generic-success.tpl.html",
				show: true,
				title: "Success",
				keyboard: false,
				backdrop: "static",
				content,
				onHide: function () {
					if (redirect) {
						$scope.allowNavigation = true;
						$state.go("patient-dashboard");
					} else {
						angular.element("body").removeClass("modal-open").css("overflow", "auto");
					}
				},
			});
		}

		/**
		 * Records which letter is being edited and who it belongs to. The author and the practice it was
		 * started at travel with the id because the same two fields decide whether this user may send or
		 * delete it - losing them leaves the letter looking like someone else's. The patient travels with
		 * it for the same reason: every later request is addressed to it (see letterPatientId).
		 */
		function recordLetterIdentity(data, letterId) {
			if (!data) {
				return;
			}
			$scope.letter.clinical_letter_id = letterId || data.clinical_letter_id;
			$scope.letter.created_by_user_id = data.created_by_user_id;
			$scope.letter.practice_id = data.practice_id;
			if (data.patient_id) {
				$scope.letter.patient_id = data.patient_id;
			}
		}

		function fetchSelectedLetter(letterId) {
			$scope.API.isProcessing = true;
			$scope.API.fetchClinicLetter(letterPatientId(), letterId)
				.then(
					function (resp) {
						$scope.letter.content = Base64.decode(resp.data.content);
						$scope.letter.clinic_date_UTC = $filter("date")(new Date(resp.data.clinic_date_UTC), "dd/MM/yyyy");
						recordLetterIdentity(resp.data, letterId);
						$scope.letter.date_completed = resp.data.date_completed;
						$scope.letter.created_by_user_full_name = resp.data.created_by_user_full_name;
						letterSignOff = {
							enabled: resp.data.sign_off_enabled,
							html: Base64.decode(resp.data.sign_off || ""),
						};
						applySignOff();

						$scope.full_recipients = {
							to: [],
							cc: [],
						};

						if ($scope.letter.date_completed) {
							$("#summernote").summernote("disable");
						}

						if(!resp.data.recipients){
							return;
						}

						resp.data.recipients.forEach((t) => {
							if (t.clinical_letter_recipient_type === "PRACTICE_DIRECTORY") {
								t.clinical_letter_recipient_send_type === "TO"
									? $scope.full_recipients.to.push({
											obj: t.practice_directory,
											name: t.practice_directory.practice_name,
											type: "PRACTICE_DIRECTORY",
									  })
									: $scope.full_recipients.cc.push({
											obj: t.practice_directory,
											type: "PRACTICE_DIRECTORY",
											name: t.practice_directory.practice_name,
									  });
							} else if (t.clinical_letter_recipient_type === "EMAIL") {
								t.clinical_letter_recipient_send_type === "TO"
									? $scope.full_recipients.to.push({ name: t.email, type: "EMAIL" })
									: $scope.full_recipients.cc.push({ name: t.email, type: "EMAIL" });
							} else if (t.clinical_letter_recipient_type === "PRACTICE_ID") {
								const practice = ($scope.practiceOptions || []).find((x) => x.id === t.practice_id);
								if (!practice) {
									return;
								}
								t.clinical_letter_recipient_send_type === "TO"
									? $scope.full_recipients.to.push({ name: practice.name, type: "PRACTICE_ID", obj: practice })
									: $scope.full_recipients.cc.push({ name: practice.name, type: "PRACTICE_ID", obj: practice });
							} else if (t.clinical_letter_recipient_type === "EDI") {
								t.clinical_letter_recipient_send_type === "TO"
									? $scope.full_recipients.to.push({ name: t.edi, type: "EDI" })
									: $scope.full_recipients.cc.push({ name: t.edi, type: "EDI" });
							}
						});
					
					},
					function (error) {
						showGenericErrorModal();
					}
				)
				.finally(() => ($scope.API.isProcessing = false));
		}

		$scope.completeLetter = function () {
			// The button is disabled for anyone but the author, and the API refuses them anyway. Checked
			// here too so sending cannot be reached by any other route.
			if (!$scope.isLettersAuthor()) {
				return;
			}
			BackgroundAPIService.sendClinicLetter(
				letterPatientId(),
				$scope.letter.clinical_letter_id,
				composePayload(),
				$scope.sendHL7.value
			);
			$scope.allowNavigation = true;
			$state.go("patient-dashboard");
		};

		$scope.getToFields = [];
		$scope.getCcFields = [];

		$scope.$watch(
			"full_recipients",
			function (newValue, oldValue) {
				if (newValue) {
					$scope.getCcFields = newValue.cc;

					$scope.getToFields = newValue.to;
				}
			},
			true
		);

		$scope.fetchUser = function (value) {
			$scope.loading = true;
			return new Promise((resolve, reject) => {
				searchUser(value, resolve, reject);
			});
		};

		function searchUser(terms, resolve, reject) {
			$scope.result = [];
			$scope.noResults = false;
			$scope.API.queryCatraxUsersByTerm(terms)
				.then(
					function (resp) {
						if (resp.data) {
							$scope.result = resp.data
								.filter((x) => !$scope.user_recipients.some((y) => y.id === x.id && y.practiceId === x.practiceId))
								.map((t) => ({ ...t, fullName: t.firstName + " " + t.lastName + ` (${t.practiceName})` }));
							if ($scope.result.length === 0) {
								$scope.noResults = true;
							} else {
								$scope.noResults = false;
							}
							resolve($scope.result);
						}
					},
					function (err) {
						console.error("User search failed", err && err.status);
						$scope.noResults = true;
						$scope.result = [];
						reject(err);
					}
				)
				.then(() => ($scope.loading = false));
		}

		$scope.usersOnSelect = function (item) {
			$scope.user_recipients.push(item);
			$scope.searchTerm.term = "";
		};

		// The default recipients are filled in once per new letter. A background refresh after that only
		// refreshes the options the pickers offer - it must not add the same people again, and it must not
		// reload an open letter over whatever the user is typing.
		let defaultRecipientsAdded = false;

		const practiceAlreadyPresent = (practiceId) => {
			if (!practiceId) return false;
			const inList = (list) => list.some((r) => r.type === "PRACTICE_ID" && r.obj && r.obj.practice_id === practiceId);
			return inList($scope.full_recipients.to) || inList($scope.full_recipients.cc);
		};

		function fetchCareTeam(options) {
			const background = !!(options && options.background);
			if (!background) $scope.API.isProcessing = true;
			$scope.API.queryPatientCare(letterPatientId())
				.then(
					function (resp) {
						const careTeam = resp.data || [];
						$scope.practiceOptions = careTeam
							.filter((t) => t.practice_id)
							.map((m) => ({ ...m, id: m.practice_id, name: m.practice_name }));

						// $scope.care_team_options = resp.data.filter(t=>t.patient_care_team_member_type === 'CATTRAX_PRACTICE');

						$scope.care_team_options = careTeam.filter((t) => t.patient_care_team_contact_info);

						if (!background && !$stateParams.id && !defaultRecipientsAdded) {
							defaultRecipientsAdded = true;
							if ($scope.CP.patient.email && !emailAlreadyPresent($scope.CP.patient.email)) {
								$scope.full_recipients.to.push({ type: "EMAIL", name: $scope.CP.patient.email });
							}

							$scope.care_team_options.forEach((t) => {
								if (t.patient_care_team_member_type === "CATTRAX_PRACTICE") {
									if (!practiceAlreadyPresent(t.practice_id)) {
										$scope.full_recipients.cc.push({ type: "PRACTICE_ID", name: t.practice_name, obj: t });
									}
								} else if (t.patient_care_team_member_type === "CATTRAX_USER") {
									if (!emailAlreadyPresent(t.patient_care_team_contact_info.EMAIL)) {
										$scope.full_recipients.cc.push({
											type: "EMAIL",
											name: t.user_full_name,
											obj: t.patient_care_team_contact_info.EMAIL,
										});
									}
								}
							});

							const gpInfo = $scope.CP.getGP($scope.CP.patient.id);

							if (gpInfo) {
								processGPInfo(gpInfo);
							}
						}
					},
					function (error) {
						console.error("Fetch care team failed", error && error.status);
					}
				)
				.then(() => {
					if (background) {
						return;
					}
					$scope.API.isProcessing = false;
					if ($stateParams.id) {
						fetchSelectedLetter($stateParams.id);
					}
				});
		}

		$scope.$on("$destroy", () => {
			angular.element("body").removeClass("modal-open").css("overflow", "auto");
			// Registered on $rootScope, so it outlives this controller unless it is taken off again -
			// otherwise every visit to this screen leaves another guard holding a dead scope.
			deregisterStateChangeStart();
		});

		function formatPractitioner() {
			if (!$scope.templateMappings) {
				$scope.templateMappings = {};
			}

			if ($scope.CP.patient.practitioners && $scope.CP.patient.practitioners.length > 0) {
				let practitioner = $scope.CP.patient.practitioners[0].practitioner;
				const organisation = $scope.CP.patient.practitioners[0].organisation;
				let org = organisation && organisation.name;
				if (!practitioner) {
					practitioner = "unknown";
				} else {
					practitioner = org ? `${practitioner.name}, ${org}` : practitioner.name;
				}
				$scope.templateMappings["${GP}"] = () => practitioner;
				// The GP's organisation is added as a recipient by processGPInfo(), to CC and only on a new
				// letter. Adding it to TO here as well sent the GP two copies, and added it to saved letters.

				return;
			}
			$scope.templateMappings["${GP}"] = () => UNAVAILABLE;
		}

		function fetchVisionData() {
			PatientVisionAPI.getPatientVision($scope.CP.patient.id).then(
				function (resp) {
					$scope.visionData = resp.data;
				},
				function (error) {}
			);
		}

		function fetchDiagnosis() {
			if (!Session.hasPermission("CLINICAL_DIAGNOSIS_VIEW")) return;
			DiagnosisAPI.getDiagnosis($scope.CP.patient.id).then(
				function (resp) {
					const array = resp.data
						.filter((t) => t.type === "OCULAR")
						.map((t) => {
							if (t.snomed_concept.fsn.term.endsWith("(procedure)")) {
								return { ...t, internal_type: 1, date_diagnosis_onset: new Date(t.date_diagnosis_onset) };
							}
							return { ...t, internal_type: 0, date_diagnosis_onset: new Date(t.date_diagnosis_onset) };
						});
					array.sort(function compareFn(a, b) {
						if (new Date(a.date_diagnosis_onset) > new Date(b.date_diagnosis_onset)) {
							return -1;
						}
						if (new Date(a.date_diagnosis_onset) < new Date(b.date_diagnosis_onset)) {
							return 1;
						}
						return 0;
					});
					array.sort(function compareFn(a, b) {
						if (a.internal_type > b.internal_type) {
							return 1;
						}
						if (a.internal_type < b.internal_type) {
							return -1;
						}
						return 0;
					});
					const simple_rows = [];
					const od_array_simple = array.filter((t) => t.laterality === "OD" && t.status === "ACTIVE");
					const os_array_simple = array.filter((t) => t.laterality === "OS" && t.status === "ACTIVE");

					const rows_count_simple = Math.max(od_array_simple.length, os_array_simple.length);
					for (let i = 0; i < rows_count_simple; i++) {
						simple_rows.push({ od: od_array_simple[i], os: os_array_simple[i] });
					}
					$scope.diagnosisData = simple_rows;
					$scope.templateMappings["${DIAGNOSIS}"] = () => drawTable().outerHTML;
				},
				function (error) {}
			);
		}

		function covertLineLetter(lineVal, letterVal) {
			if (!lineVal || letterVal == null) {
				return UNAVAILABLE;
			}
			const element = LINE.find((t) => t.value === lineVal);
			let result = "";
			if (element) {
				if (element.name === "CF" || element.name === "HM" || element.name === "POL" || element.name === "NPL") {
					return element.name;
				} else {
					result = `6/${element.name}`;
				}
			}
			if (letterVal > 0) {
				result = result + `+${letterVal}`;
			} else if (letterVal < 0) {
				result = result + letterVal;
			}
			return result;
		}

		function transformDeviceName(value) {
			const element = DEVICE.find((t) => t.value === value);
			if (element) {
				return `(${element.name})`;
			}
			return "";
		}

		const UNAVAILABLE = '<font color="#9c9c94">N/A</font>';

		// The vision record may not have loaded (or may not exist) when a template is applied.
		function eyeVision(eye) {
			return ($scope.visionData && $scope.visionData.vision && $scope.visionData.vision[eye]) || null;
		}

		function formatIOP(vision) {
			if (!vision || vision.intraocular_pressure_iop == null) {
				return UNAVAILABLE;
			}
			return `${vision.intraocular_pressure_iop} ${transformDeviceName(vision.intraocular_pressure_device)}`;
		}

		function formatRefraction(vision) {
			if (!vision || (vision.refraction_sphere == null && vision.refraction_cylinder == null)) {
				return UNAVAILABLE;
			}
			const part = (value) => (value == null ? "" : value);
			return `${part(vision.refraction_sphere)}/${part(vision.refraction_cylinder)} x ${part(vision.refraction_axis)}deg ${
				vision.auto_refraction ? "(auto)" : ""
			}`;
		}

		// Values substituted into template HTML are text, so they are escaped - a patient or GP name must
		// not be able to add markup to the letter. UNAVAILABLE and the diagnosis table are the only
		// placeholders whose value is HTML we built ourselves.
		function escapeHtml(value) {
			return String(value)
				.replace(/&/g, "&amp;")
				.replace(/</g, "&lt;")
				.replace(/>/g, "&gt;")
				.replace(/"/g, "&quot;")
				.replace(/'/g, "&#39;");
		}

		function templateValue(key) {
			const value = $scope.templateMappings[key]();
			if (value == null) {
				return "";
			}
			if (key === "${DIAGNOSIS}" || value === UNAVAILABLE) {
				return value;
			}
			return escapeHtml(value);
		}

		function createTemplateMappings() {
			$scope.templateMappings = {
				"${GP}": () => "${GP}",
				"${PATIENT_FIRST_NAME}": () => $scope.CP.patient.firstName,
				"${PATIENT_LAST_NAME}": () => $scope.CP.patient.lastName,
				"${CLINIC_DATE}": () => $filter("date")($scope.letter.clinic_date_UTC, "dd/MM/yyyy"),
				"${DATE_LETTER_CREATION}": () => $scope.today,
				"${PRACTICE_NAME}": () => $scope.Session.practice.name,
				"${PRACTICE_EMAIL}": () => $scope.Session.practice.email,
				"${DATE_OF_BIRTH}": () => $filter("date")($scope.CP.patient.dateOfBirth, "dd/MM/yyyy"),
				"${NHI}": () => ($scope.CP.patient.nhi ? $scope.CP.patient.nhi : UNAVAILABLE),
				"${OD_UCVA}": () =>
					covertLineLetter(eyeVision("od")?.uncorrected_va_line, eyeVision("od")?.uncorrected_va_letter),
				"${OS_UCVA}": () =>
					covertLineLetter(eyeVision("os")?.uncorrected_va_line, eyeVision("os")?.uncorrected_va_letter),
				"${OD_BCVA}": () => covertLineLetter(eyeVision("od")?.best_va_line, eyeVision("od")?.best_va_letter),
				"${OS_BCVA}": () => covertLineLetter(eyeVision("os")?.best_va_line, eyeVision("os")?.best_va_letter),
				"${OD_PINHOLE}": () => covertLineLetter(eyeVision("od")?.pinhole_va_line, eyeVision("od")?.pinhole_va_letter),
				"${OS_PINHOLE}": () => covertLineLetter(eyeVision("os")?.pinhole_va_line, eyeVision("os")?.pinhole_va_letter),
				"${OD_IOP}": () => formatIOP(eyeVision("od")),
				"${OS_IOP}": () => formatIOP(eyeVision("os")),
				"${OD_REFRACTION}": () => formatRefraction(eyeVision("od")),
				"${OS_REFRACTION}": () => formatRefraction(eyeVision("os")),
			};

			if (!$scope.visionData) {
				fetchVisionData();
			}

			if (!$scope.diagnosisData) {
				fetchDiagnosis();
			}
		}

		$scope.$watch(
			"CP.patient.practitioners",
			function (newValue, oldValue) {
				if (newValue) {
					formatPractitioner();
					$scope.letter.content = _applyTemplateGP($scope.letter.content);
				}
			},
			true
		);

		function _applyTemplateGP(decodedContent) {
			let newContent = decodedContent;
			["${GP}"].forEach((t) => {
				const value = templateValue(t);
				// A function replacement, so "$&" and friends in a value are not treated as patterns.
				newContent = newContent.replaceAll(t, () => value);
			});
			return newContent;
		}

		function applyTemplateParameters(decodedContent) {
			let newContent = decodedContent;
			Object.keys($scope.templateMappings).forEach((t) => {
				const value = templateValue(t);
				newContent = newContent.replaceAll(t, () => value);
			});
			return newContent;
		}
		$scope.toolbar_sign_btn = null;
		$scope.toolbar_create_update_signature_btn = null;
		// $scope.toolbar_gp_btn = null;
		function initButton(context, name, tooltip, key) {
			var ui = $.summernote.ui;

			// create button
			var button = ui.button({
				contents: `<i class="fa"/> ${name}`,
				tooltip,
				click: function () {
					const span = document.createElement("span");

					if ($scope.templateSetting.checked) {
						span.innerText = key;
					} else {
						const content = $scope.templateMappings[key]();
						if (content === UNAVAILABLE) {
							span.innerHTML = UNAVAILABLE;
						} else {
							span.innerText = content;
						}
					}

					context.invoke("editor.insertNode", span);
				},
			});

			return button.render(); // return button as jquery object
		}

		var SignButton = function (context) {
			var ui = $.summernote.ui;

			// create button
			var button = ui.button({
				contents: '<i class="fa fa-pencil-square-o"/> Signature',
				tooltip: "Signature",
				click: function () {
					// invoke insertText method with 'hello' on editor module.
					// context.invoke('editor.insertText', 'hello');
					const img = document.createElement("img");
					img.setAttribute("src", $scope.saved_user_signature_image);
					// img.attr({ src: $scope.saved_user_signature_image })
					context.invoke("editor.insertNode", img);
				},
			});
			$scope.toolbar_sign_btn = button.render();
			return $scope.toolbar_sign_btn; // return button as jquery object
		};

		var UpdateSignatureButton = function (context) {
			var ui = $.summernote.ui;

			const title = $scope.saved_user_signature_image ? "Update Signature" : "Create Signature";

			// create button
			var button = ui.button({
				contents: `<i class="fa fa-pencil-square-o"/> ${title}`,
				tooltip: title,
				click: function () {
					$scope.openSignatureModal();
				},
			});
			$scope.toolbar_create_update_signature_btn = button.render();
			return $scope.toolbar_create_update_signature_btn; // return button as jquery object
		}

		$scope.openSignatureModal = function () {
			$scope.signatureClinician = $scope.saved_user_signature_image
				? { dataUrl: $scope.saved_user_signature_image }
				: {};
			$scope.uploadedItem = {};
			$scope.signatureModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.preview-sign.tpl.html",
				show: true,
				title: $scope.saved_user_signature_image ? "Update Signature" : "Create Signature",
				backdrop: "static",
				keyboard: false,
			});
			angular.element("body").removeClass("modal-open").css("overflow", "auto");
		};

		var FirstNameButton = function (context) {
			return initButton(context, "First Name", "patient first name", "${PATIENT_FIRST_NAME}");
		};

		var LastNameButton = function (context) {
			return initButton(context, "Last Name", "patient last name", "${PATIENT_LAST_NAME}");
		};

		var ClinicDateButton = function (context) {
			return initButton(context, "Clinic Date", "clinic date", "${CLINIC_DATE}");
		};

		var LetterCreationButton = function (context) {
			return initButton(context, "Creation Date", "creation date", "${DATE_LETTER_CREATION}");
		};

		var PracticeNameButton = function (context) {
			return initButton(context, "Practice Name", "practice name", "${PRACTICE_NAME}");
		};

		var PracticeEmailButton = function (context) {
			return initButton(context, "Practice Email", "practice email", "${PRACTICE_EMAIL}");
		};

		var DOBButton = function (context) {
			return initButton(context, "DOB", "date of birth", "${DATE_OF_BIRTH}");
		};

		var NHIButton = function (context) {
			return initButton(context, "NHI", "NHI", "${NHI}");
		};

		var GPButton = function (context) {
			return initButton(context, "GP", "GP", "${GP}");
		};

		var OD_UCVAButton = function (context) {
			return initButton(context, "OD UCVA", "OD UCVA", "${OD_UCVA}");
		};

		var OS_UCVAButton = function (context) {
			return initButton(context, "OS UCVA", "OS UCVA", "${OS_UCVA}");
		};

		var OD_BCVAButton = function (context) {
			return initButton(context, "OD BCVA", "OD BCVA", "${OD_BCVA}");
		};

		var OS_BCVAButton = function (context) {
			return initButton(context, "OS BCVA", "OS BCVA", "${OS_BCVA}");
		};

		var OD_PINHOLEButton = function (context) {
			return initButton(context, "OD PINHOLE", "OD PINHOLE", "${OD_PINHOLE}");
		};

		var OS_PINHOLEButton = function (context) {
			return initButton(context, "OS PINHOLE", "OS PINHOLE", "${OS_PINHOLE}");
		};

		var OD_IOPButton = function (context) {
			return initButton(context, "OD IOP", "OD IOP", "${OD_IOP}");
		};

		var OS_IOPButton = function (context) {
			return initButton(context, "OS IOP", "OS IOP", "${OS_IOP}");
		};

		var OD_REFRACTIONButton = function (context) {
			return initButton(context, "OD REFRACTION", "OD REFRACTION", "${OD_REFRACTION}");
		};

		var OS_REFRACTIONButton = function (context) {
			return initButton(context, "OS REFRACTION", "OS REFRACTION", "${OS_REFRACTION}");
		};

		var DiagnosesButton = function (context) {
			var ui = $.summernote.ui;

			// create button
			var button = ui.button({
				contents: '<i class="fa"/> Diagnoses',
				tooltip: "Diagnoses",
				click: function () {
					if ($scope.templateSetting.checked) {
						const span = document.createElement("span");
						span.innerText = "${DIAGNOSIS}";
						context.invoke("editor.insertNode", span);
					} else {
						context.invoke("editor.insertNode", drawTable());
					}
				},
			});

			return button.render(); // return button as jquery object
		};

		function drawTable() {
			const table = document.createElement("table");
			const body = document.createElement("tbody");
			table.setAttribute("class", "table table-bordered note-editor-diagnosis-table");
			table.appendChild(body);

			const tr = document.createElement("tr");
			const td1 = document.createElement("td");
			const text = document.createTextNode("OD");
			td1.appendChild(text);
			tr.appendChild(td1);

			const td2 = document.createElement("td");
			const text2 = document.createTextNode("OS");
			td2.appendChild(text2);
			tr.appendChild(td2);
			tr.appendChild(td2);

			body.appendChild(tr);

			($scope.diagnosisData || []).forEach((r) => {
				const row = document.createElement("tr");
				body.appendChild(row);

				const td_od = document.createElement("td");
				let string_od = "";
				if (r.od) {
					string_od = r.od.snomed_concept.pt.term;
				}
				const text_od = document.createTextNode(string_od);
				td_od.appendChild(text_od);
				row.appendChild(td_od);

				const td_os = document.createElement("td");
				let string_os = "";
				if (r.os) {
					string_os = r.os.snomed_concept.pt.term;
				}
				const text_os = document.createTextNode(string_os);
				td_os.appendChild(text_os);
				row.appendChild(td_os);
			});
			return table;
		}

		/**
		 * Whether the logged-in user is the one who can send this letter. Anyone at the practice may open
		 * a colleague's draft, edit it and preview it, but sending is the clinician's own act, so only the
		 * user who started the letter may do it, and only from the practice they started it at. The API
		 * enforces both; this is what keeps the user from finding out by being refused.
		 *
		 * A letter that has not been started yet has no author recorded, and belongs to whoever is writing
		 * it.
		 */
		$scope.isLettersAuthor = () => {
			const letter = $scope.letter;
			if (!letter || !letter.clinical_letter_id) {
				return true;
			}
			return letter.created_by_user_id === Session.user.id && letter.practice_id === Session.practice.id;
		};

		/**
		 * Why the send button is disabled, so a user reading a colleague's letter is told rather than left
		 * guessing. Returns nothing when sending is available.
		 */
		$scope.sendDisabledReason = () => {
			if (!$scope.isLettersAuthor()) {
				const letter = $scope.letter || {};
				return letter.created_by_user_id === Session.user.id
					? "This letter was started at another practice. It can only be sent from there."
					: "Only the clinician who started this letter can send it. You can still edit and save it.";
			}
			return "";
		};

		$scope.isSendDisabled = () => {
			return (
				($scope.full_recipients.cc.length === 0 && $scope.full_recipients.to.length === 0) ||
				$scope.isOverSize ||
				$scope.templateSetting.checked ||
				!$scope.isLettersAuthor()
			);
		};

		/*
		 * The sign-off beneath the letter text. It is the author's: the server adds it to the PDF with
		 * their handwritten signature, using the letter's own sign-off if it has one and the author's
		 * saved default otherwise. So a letter only carries a sign-off of its own once the author edits
		 * it here - until then it follows their default, and shows the latest version of it.
		 */
		$scope.signOff = {
			// Letters written before sign-offs existed have one typed into their text; they get no section.
			visible: false,
			enabled: true,
			html: "",
			// Whether this letter has its own sign-off rather than following the author's default.
			isCustom: false,
			defaultHtml: "",
			hasDefault: false,
			status: "",
		};

		let signOffSettingsLoaded = false;
		// The loaded letter's sign-off, or null for a new letter.
		let letterSignOff = null;

		function loadSignOffSettings() {
			$scope.API.getUserSettings().then(
				function (resp) {
					$scope.signOff.defaultHtml = Base64.decode(resp.data.sign_off || "");
					$scope.signOff.hasDefault = SignOffService.hasContent($scope.signOff.defaultHtml);
					signOffSettingsLoaded = true;
					applySignOff();
				},
				function (error) {
					// Without the default the section can't be shown, and a letter saved without it
					// still gets the author's default on the server.
					console.error("Fetch letter sign-off settings failed", error && error.status);
				}
			);
		}

		/** Sets the sign-off section up once both the user's default and the letter (if any) are in. */
		function applySignOff() {
			if (!signOffSettingsLoaded || ($stateParams.id && !letterSignOff)) {
				return;
			}
			const signOff = $scope.signOff;

			if (letterSignOff) {
				signOff.visible = letterSignOff.enabled === true || letterSignOff.enabled === false;
				signOff.enabled = letterSignOff.enabled === true;
				signOff.isCustom = SignOffService.hasContent(letterSignOff.html);

				if (signOff.isCustom) {
					signOff.html = letterSignOff.html;
					return;
				}

				// Someone else's letter, or one already sent: the viewer's own default has no place in
				// it. A sent letter keeps the sign-off it went out with, so without one there is nothing
				// to show.
				if (!$scope.canEditSignOff()) {
					signOff.html = "";
					if ($scope.letter.date_completed) {
						signOff.visible = false;
					}
					return;
				}
			} else {
				signOff.visible = true;
				signOff.enabled = true;
				signOff.isCustom = false;
			}

			if (signOff.hasDefault) {
				signOff.html = signOff.defaultHtml;
			} else {
				// Nothing saved yet: start one from their name. It has to travel with the letter,
				// since there is no default for the server to fall back on.
				signOff.html = SignOffService.starterHtml(Session.user);
				signOff.isCustom = true;
			}
		}

		function composeSignOffPayload() {
			// Only the author's changes count; the server ignores anyone else's.
			if (!$scope.signOff.visible || !$scope.isLettersAuthor()) {
				return {};
			}
			return {
				sign_off_enabled: $scope.signOff.enabled,
				// Blank means "use my default", so the letter keeps following it.
				sign_off: $scope.signOff.isCustom ? Base64.encode($scope.signOff.html) : "",
			};
		}

		/** Whether the sign-off can be edited here: by its author, before the letter is sent. */
		$scope.canEditSignOff = () => $scope.isLettersAuthor() && !$scope.letter.date_completed;

		/** For anyone but the author, a letter following the author's default has nothing to show yet. */
		$scope.signOffFollowsAuthorsDefault = () => !$scope.canEditSignOff() && !$scope.signOff.isCustom && !$scope.letter.date_completed;

		/** Whose signature the placeholder stands for when the image can't be shown. */
		$scope.signOffPlaceholderLabel = () => {
			if ($scope.isLettersAuthor()) {
				return "Your signature";
			}
			return $scope.letter.created_by_user_full_name ? `${$scope.letter.created_by_user_full_name}'s signature` : "Signature";
		};

		/** The author's own signature; never shown on someone else's letter. */
		$scope.signOffSignature = () => ($scope.isLettersAuthor() ? $scope.saved_user_signature_image : null);

		$scope.onSignOffChange = function (html, edited) {
			$scope.signOff.html = html;
			if (edited) {
				$scope.signOff.isCustom = true;
				$scope.signOff.status = "";
				$scope.allowNavigation = false;
			}
		};

		$scope.onSignOffEnabledChange = function () {
			$scope.allowNavigation = false;
		};

		/** Drops this letter's changes so it follows the author's default again. */
		$scope.resetSignOff = function () {
			$scope.signOff.html = $scope.signOff.defaultHtml;
			$scope.signOff.isCustom = false;
			$scope.signOff.status = "";
			$scope.allowNavigation = false;
		};

		/** Saves this letter's sign-off as the author's default, so this letter follows it too. */
		$scope.saveSignOffAsDefault = function () {
			$scope.signOff.status = "saving";
			$scope.API.updateUserSettings({ sign_off: Base64.encode($scope.signOff.html) }).then(
				function (resp) {
					$scope.signOff.defaultHtml = Base64.decode(resp.data.sign_off || "");
					$scope.signOff.hasDefault = SignOffService.hasContent($scope.signOff.defaultHtml);
					$scope.signOff.html = $scope.signOff.defaultHtml;
					$scope.signOff.isCustom = false;
					$scope.signOff.status = "saved";
				},
				function (error) {
					console.error("Save letter sign-off failed", error && error.status);
					$scope.signOff.status = "save-error";
				}
			);
		};

		$scope.onToRecipientChange = (recipients) => {
			$scope.full_recipients.to = [...recipients];
		};

		$scope.onCcRecipientChange = (recipients) => {
			$scope.full_recipients.cc = [...recipients];
		};

		function FooterButton(context) {
			var ui = $.summernote.ui;
			// create button
			var button = ui.button({
				contents: `<i class="fa"/> Add footer`,
				tooltip: "Add footer",
				click: function () {
					var editor = $("#summernote");
					var currentContent = editor.summernote("code");

					var updatedContent = currentContent + "<p><br></p>";
					editor.summernote("code", updatedContent);

					// Get the editable area
					var editable = editor.next(".note-editor").find(".note-editable")[0];

					// Create a range and selection
					var range = document.createRange();
					var selection = window.getSelection();

					// Move range to the end of the content
					range.selectNodeContents(editable);
					range.collapse(false); // Collapse to end

					// Apply the range
					selection.removeAllRanges();
					selection.addRange(range);
					context.modules.imageDialog.show();
				},
			});

			return button.render(); // return button as jquery object
		}

		$scope.paste = function (e) {
			// need to santinize html
			setTimeout(() => {
				$scope.letter.content = sanitizer($scope.letter.content);
			}, 100);
		};

		function sanitizer(htmlString) {
			// Parse the string into a DOM
			let parser = new DOMParser();
			let doc = parser.parseFromString(htmlString, "text/html");

			// Update all spans
			doc.querySelectorAll("span").forEach((span) => {
				let currentStyle = span.getAttribute("style") || "";
				if (!span.style?.fontSize) {
					// Append font-size
					span.setAttribute("style", currentStyle + "font-size:12px;");
				}
			});

			// For each <p>, wrap its child nodes in <span>
			doc.querySelectorAll("p").forEach((p) => {
				let children = Array.from(p.childNodes);
				children.forEach((child) => {
					// Skip if already a span
					if (child.nodeType === Node.ELEMENT_NODE && child.tagName === "SPAN") return;

					let span = doc.createElement("span");
					span.setAttribute("style", "font-size:12px;");
					span.appendChild(child.cloneNode(true));
					p.replaceChild(span, child);
				});
			});

			//Fix pdf generation issue: copy xml from word without proper attribute value, remove <o:p>
			const elements = doc.getElementsByTagName("o:p");

			while (elements.length > 0) {
				const el = elements[0];
				const parent = el.parentNode;
				while (el.firstChild) {
					parent.insertBefore(el.firstChild, el);
				}
				parent.removeChild(el);
			}

			// Get back the updated HTML string
			return doc.body.innerHTML;
		}

		$scope.options = {
			height: "48vh",
			focus: true,
			disableResizeEditor: true,
			placeholder: "write here...",
			fontNames: ["Gordita Regular", "Arial", "Georgia", "Times New Roman", "Courier New", "Verdana"],
			// Show these fonts regardless of whether the browser reports them as installed.
			fontNamesIgnoreCheck: ["Gordita Regular", "Arial", "Georgia", "Times New Roman", "Courier New", "Verdana"],
			toolbar: [
				["pagebreak", ["pagebreak", "sign","signature"]],
				["edit", ["undo", "redo"]],
				["headline", ["style"]],
				["style", ["bold", "italic", "underline", "superscript", "subscript", "strikethrough", "clear"]],
				["fontface", ["fontname"]],
				["textsize", ["fontsize"]],
				["fontclr", ["color"]],
				["alignment", ["ul", "ol", "paragraph", "lineheight"]],
				["height", ["height"]],
				["table", ["table"]],
				["insert", ["link", "picture"]],
				[
					"misc",
					[
						"print",
						"firstName",
						"lastName",
						"clinicDate",
						"creation",
						"practiceName",
						"practiceEmail",
						"dob",
						"nhi",
						"gp",
						"odUcva",
						"osUcva",
						"osBcva",
						"odBcva",
						"odPinhole",
						"osPinhole",
						"odIOP",
						"osIOP",
						"odRefraction",
						"osRefraction",
						"diagnosis",
						"addFooter",
					],
				],
			],
			buttons: {
				sign: SignButton,
				signature: UpdateSignatureButton,
				firstName: FirstNameButton,
				lastName: LastNameButton,
				clinicDate: ClinicDateButton,
				creation: LetterCreationButton,
				practiceName: PracticeNameButton,
				practiceEmail: PracticeEmailButton,
				dob: DOBButton,
				nhi: NHIButton,
				gp: GPButton,
				odUcva: OD_UCVAButton,
				osUcva: OS_UCVAButton,
				osBcva: OS_BCVAButton,
				odBcva: OD_BCVAButton,
				odPinhole: OD_PINHOLEButton,
				osPinhole: OS_PINHOLEButton,
				odIOP: OD_IOPButton,
				osIOP: OS_IOPButton,
				odRefraction: OD_REFRACTIONButton,
				osRefraction: OS_REFRACTIONButton,
				diagnosis: DiagnosesButton,
				addFooter: FooterButton,
			},
		};
	},
]);